import React from "react";
import {
  Button,
  Row,
  Col,
  Tooltip,
} from "antd";
import {
  UpSquareFilled,
  DownSquareFilled,
} from "@ant-design/icons";

const FTPControls = ({
  isMobile = false,
  FTP,
  additionalPower,
  onAdjustFTP,
  controlHeight = 64,
  controlHeightMobile = 52,
}) => {
  const height = isMobile ? controlHeightMobile : controlHeight;

  return (
    <Row gutter={isMobile ? 8 : 6} align="middle" wrap={false} style={{ width: "100%" }}>
      {/* Left arrow beside target */}
      <Col flex={`${height}px`}>
        <Tooltip title="Decrease target power">
          <Button
            id="tour-ftp-down"
            shape="circle"
            className="primary-glass-btn"
            onClick={() => {
              onAdjustFTP(-1);
            }}
            aria-label="Decrease target power"
            style={{ width: height, height }}
          >
            <DownSquareFilled />
          </Button>
        </Tooltip>
      </Col>

      {/* Target rectangle fills remaining width */}
      <Col flex="auto" style={{ margin: isMobile ? "0 8px" : "0 6px" }}>
        <div
          style={{
            textAlign: "center",
            height,
            borderRadius: 12,
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.55), rgba(255,255,255,0.25))",
            border: "1px solid rgba(0,0,0,0.18)",
            boxShadow:
              "inset 0 1px 0 rgba(255,255,255,0.35), 0 2px 10px rgba(0,0,0,0.08)",
            color: "rgba(0,0,0,0.78)",
            fontWeight: 600,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontSize: isMobile ? "0.75em" : undefined,
          }}
          aria-label="Target power display"
        >
          Target {FTP + additionalPower} W
          <div style={{ fontSize: 12, fontWeight: 500, opacity: 0.75 }}>
            FTP initial: {FTP} W
          </div>
        </div>
      </Col>

      {/* Right arrow beside target */}
      <Col flex={`${height}px`}>
        <Tooltip title="Increase target power">
          <Button
            id="tour-ftp-up"
            shape="circle"
            className="primary-glass-btn"
            onClick={() => {
              onAdjustFTP(1);
            }}
            aria-label="Increase target power"
            style={{ width: height, height }}
          >
            <UpSquareFilled />
          </Button>
        </Tooltip>
      </Col>
    </Row>
  );
};

export default FTPControls;
